<script lang="ts" setup>
import { Button } from '@/foundation/button'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/foundation/tooltip'
import { Icon } from '@/notebook/components/icons'
import { type ButtonViewReturnComponentProps } from '@/notebook/type'
import { cn } from '@/notebook/utils'
import { getShortcutKeys } from '@/notebook/utils/plateform'

type Props = {
  icon?: any
  class?: string
  title?: string
  tooltip?: string
  disabled?: boolean
  shortcutKeys?: string[]
  color?: string
  action?: ButtonViewReturnComponentProps['action']
  isActive?: ButtonViewReturnComponentProps['isActive']
}
const props = withDefaults(defineProps<Props>(), {
  icon: undefined,
  title: undefined,
  tooltip: undefined,
  disabled: false,
  color: undefined,
  shortcutKeys: undefined,
  action: undefined,
  isActive: undefined,
  class: '',
})
</script>

<template>
  <TooltipProvider>
    <Tooltip :delay-duration="0">
      <TooltipTrigger as-child>
        <Button :class="cn('h-[32px] px-1.5 py-0', props.class)" variant="ghost" :disabled="disabled">
          <div class="flex items-center h-full justify-between font-normal w-full">
            <div v-if="title" class="text-left truncate text-sm flex-grow">{{ title }}</div>
            <Icon v-if="icon" class="w-[16px] h-[16px]" :name="icon" />
            <Icon class="w-3 h-3 ml-1 text-muted-foreground flex-shrink-0" name="MenuDown" />
          </div>
        </Button>
      </TooltipTrigger>
      <TooltipContent v-if="tooltip || (shortcutKeys && shortcutKeys.length)">
        <div class="max-w-24 text-center flex flex-col items-center">
          <div>{{ tooltip }}</div>
          <div v-if="shortcutKeys && shortcutKeys.length" class="flex">
            <span>{{ getShortcutKeys(shortcutKeys) }}</span>
          </div>
        </div>
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
</template>
